export enum InvoiceOperationType {
  PRODUCT = "product",
  SERVICE = "service",
}

export enum InvoiceOperationStatus {
  IN_PROGRESS = "in_progress",
  CANCELLED = "cancelled",
  AUTHORIZED = "authorized",
  WAITING_AUTHORIZATION = "waiting_authorization",
}

export const STATUS_INVOICE_OPERATION_LABELS = {
  [InvoiceOperationStatus.IN_PROGRESS]: "Em andamento",
  [InvoiceOperationStatus.CANCELLED]: "Cancelada",
  [InvoiceOperationStatus.AUTHORIZED]: "Autorizada",
  [InvoiceOperationStatus.WAITING_AUTHORIZATION]: "Aguardando autorização",
};

export const STATUS_INVOICE_OPERATION_TYPE = {
  [InvoiceOperationType.PRODUCT]: "Produto",
  [InvoiceOperationType.SERVICE]: "Serviço",
};

export type InvoiceItem = {
  description: string;
  quantity: number;
  amount: number;
};

export type InvoiceOperationNatureOperation = 'SALE' | 'RETURN' | 'TRANSFER'

export interface IInvoiceOperation {
  _id?: string;
  companyId: string;
  partner: { _id: string; companyName: string };
  customerId: { _id: string, companyName: string} | string;
  status: InvoiceOperationStatus | string;
  type: InvoiceOperationType | null;
  dateEmission: Date;
  amount: number;
  natureOperation: InvoiceOperationNatureOperation | string;
  items: InvoiceItem[];
  note?: string;
}
